export const storyList = [
    'about_missing',
    'about_kindness',
    'about_forgiveness',
    'about_companion',
    'about_courage',
    'about_love',
    'about_reunion'
]

export const indexData = [
    {
        "id": 4,
        "story": "about_companion",
        "name": "謝謝你，陌生人",
        "cover": "ben/npm/images/index/story/about_companion.png",
        "label": "環狀線 - 主題列車限定故事<br>12/25 正式推出",
        "label_opened": "點擊劇照立即觀賞！",
        "intro": "一位疲憊的上班族<br>在深夜的捷運站，與落寞的老先生相遇<br>發生什麼事，讓原本低潮的兩人<br>成為彼此心靈的救贖？",
        "opening_date": "2023, 11, 25",
        "modal_info": {
            "name": "謝謝你，陌生人",
            "location": "環狀線主題列車",
            "time": "2023/12/25 ～ 2024/1/7",
            "guide": "搭乘主題列車<br>體驗互動式故事，主導劇情走向"
        }
    },
    {
        "id": 3,
        "story": "about_forgiveness",
        "name": "直球對決，很難嗎？",
        "cover": "ben/npm/images/index/story/about_forgiveness.png",
        "label": "環狀線 - 主題列車限定故事<br>12/18 正式推出",
        "label_opened": "點擊劇照立即觀賞！",
        "intro": "在充滿人潮的捷運上<br>和兩顆愛慕的心不期而遇<br>我成了他們的旁觀者<br>發現自己也被這段愛情所牽動",
        "opening_date": "2023, 11, 18",
        "modal_info": {
            "name": "直球對決，很難嗎？",
            "location": "環狀線主題列車",
            "time": "2023/12/18 ～ 2024/1/7",
            "guide": "搭乘主題列車<br>體驗互動式故事，主導劇情走向"
        }
    },
    {
        "id": 2,
        "story": "about_kindness",
        "name": "媽，我回來了",
        "cover": "ben/npm/images/index/story/about_kindness.png",
        "label": "環狀線 - 主題列車限定故事",
        "label_opened": "點擊劇照立即觀賞！",
        "intro": "一位行動不便的婆婆向我搭話<br>轉頭看著她佈滿歲月痕跡的臉<br>讓我想起了在家鄉的親人<br>有多久沒回家了呢？",
        "opening_date": "2023, 11, 11",
        "modal_info": {
            "name": "媽，我回來了",
            "location": "環狀線主題列車",
            "time": "2023/12/1 ～ 2024/1/7",
            "guide": "搭乘主題列車<br>體驗互動式故事，主導劇情走向"
        }
    },
    {
    "id": 1,
        "story": "about_missing",
        "name": "至少，要有點樣子",
        "cover": "ben/npm/images/index/story/about_missing.png",
        "label": "網頁限定！點擊劇照立即觀賞！",
        "label_opened": "點擊劇照立即觀賞！",
        "intro": "「為什麼我們沒想過要在一起？」<br>互有好感卻不斷錯過的兩人<br>靜靜地看著彼此思考著<br>這次，能牽起彼此的手嗎？",
        "opening_date": "2023, 11, 1",
        "modal_info": {
            "name": "至少，要有點樣子",
            "location": "本網頁，以及環狀線 - 主題列車",
            "time": "2023/12/1 ～ 2024/1/7",
            "guide": "再稍微等一下！<br>2023/12/1 即可在此網頁觀賞該劇情"
        }
    },
    {
        "id": 5,
        "story": "about_courage",
        "name": "如果身邊是你愛的人",
        "cover": "ben/npm/images/index/story/about_courage.png",
        "label": "環狀線板橋站<br>主題故事放映中",
        "label_opened": "環狀線板橋站<br>主題故事放映中",
        "intro": "他和她，一直是那種微妙的關係<br>這聖誕夜，機會就在眼前<br>他敢不敢跨出那一步<br>從朋友變成...？",
        "opening_date": "2023, 11, 5",
        "modal_info": {
            "name": "如果身邊是你愛的人",
            "location": "環狀線 - 板橋站 - 月台等候處",
            "time": "2023/12/1 ～ 2024/1/7",
            "guide": "搭乘主題列車<br>體驗互動式故事，主導劇情走向"
        }
    },
    {
        "id": 7,
        "story": "about_reunion",
        "name": "年夜飯的困境",
        "cover": "ben/npm/images/index/story/about_reunion.png",
        "label": "環狀線景安站<br>主題故事放映中",
        "label_opened": "環狀線景安站<br>主題故事放映中",
        "intro": "身處夫家的廚房<br>準備大家的團圓飯<br>心中滿是對父親的愧疚和掛念<br>今年除夕，要回家過嗎？",
        "opening_date": "2023, 11, 18",
        "modal_info": {
            "name": "年夜飯的困境",
            "location": "環狀線 - 景安站",
            "time": "2023/12/1 ～ 2024/1/7",
            "guide": "搭乘主題列車<br>體驗互動式故事，主導劇情走向"
        }
    },
    {
        "id": 6,
        "story": "about_love",
        "name": "你，一直都在",
        "cover": "ben/npm/images/index/story/about_love.png",
        "label": "環狀線新北產業園區站<br>主題故事放映中",
        "label_opened": "環狀線新北產業園區站<br>主題故事放映中",
        "intro": "她離開了他，也離開了這片土地<br>10 年後再次回來<br>卻發現心底的遺憾還在<br>只是，分散後兩人還有機會嗎？",
        "opening_date": "2023, 11, 11",
        "modal_info": {
            "name": "你，一直都在",
            "location": "環狀線 - 新北產業園區站 - 月台等候處",
            "time": "2023/12/1 ～ 2024/1/7",
            "guide": "搭乘主題列車<br>體驗互動式故事，主導劇情走向"
        }
    }


]

export const stationData = [
    {
        "story": "about_courage",
        "name": "如果身邊是你愛的人",
        "view_ga":"view_landing_homepage_mrt_about_courage",
        "click_left_ga":"click_landing_homepage_mrt_about_courage_left",
        "click_right_ga":"click_landing_homepage_mrt_about_courage_right",
        "image": ["ben/npm/images/index/station/about_courage-default.png", "ben/npm/images/index/station/about_courage-active.png"],
        "label": "環狀線 - 板橋站限定",
        "choices": ["當然<br>主動才有機會", "不敢<br>怕連朋友都當不成"],
        "modal_info": {
            "image": "ben/npm/images/index/station/about_courage-guide.png",
            "question": "選擇，會影響曖昧關係嗎？",
            "guide": "2023/12/1 ～ 2024/1/7<br>前往到板橋站，找到解答"
        }
    },{
        "story": "about_love",
        "name": "你，一直都在",
        "view_ga":"view_landing_homepage_mrt_about_love",
        "click_left_ga":"click_landing_homepage_mrt_about_love_left",
        "click_right_ga":"click_landing_homepage_mrt_about_love_right",
        "image": ["ben/npm/images/index/station/about_love-default.png", "ben/npm/images/index/station/about_love-active.png"],
        "label": "環狀線 - 新北產業園區站限定",
        "choices": ["我選愛情<br>不離開", "我選麵包<br>請他等我"],
        "modal_info": {
            "image": "ben/npm/images/index/station/about_love-guide.png",
            "question": "選擇，會讓愛情直接變質嗎？",
            "guide": "2023/12/1 ～ 2024/1/7<br>前往新北產業園區站，找到解答"
        }
    },{
        "story": "about_reunione",
        "name": "年夜飯的困境",
        "view_ga":"view_landing_homepage_mrt_about_reunion",
        "click_left_ga":"click_landing_homepage_mrt_about_reunion_left",
        "click_right_ga":"click_landing_homepage_mrt_about_reunion_right",
        "image": ["ben/npm/images/index/station/about_reunion-default.png", "ben/npm/images/index/station/about_reunion-active.png"],
        "label": "環狀線 - 景安站限定",
        "choices": ["會～要等我<br>回家吃飯！", "可能初二<br>才會回家吧 ..."],
        "modal_info": {
            "image": "ben/npm/images/index/station/about_reunion-guide.png",
            "question": "選擇，會影響到和家人之間的關係嗎？",
            "guide": "2023/12/1 ～ 2024/1/7<br>前往景安站，找到解答"
        }
    }
]

export const storyData = [
    {
        "story": "about_missing",
        "opening_date": "2023, 11, 1",
        "name": "至少，要有點樣子",
        "intro": "「為什麼我們沒想過要在一起？」，互有好感卻不斷錯過的兩人，靜靜地看著彼此思考著。<br>這次，能牽起彼此的手嗎？",
        "qrcode": "ben/npm/images/cover/qrcode-about_missing.png",
        "cover": "ben/npm/images/cover/about_missing.png",
        "cover_onelink": "https://dcard.link/CakXH4",
        "story_script": [
            {
                "page": 1,
                "img_page": "ben/npm/images/story/about_missing/p1.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p1-d1.png", "ben/npm/images/story/about_missing/p1-d2.png", "ben/npm/images/story/about_missing/p1-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/T7zIr0"
            },{
                "page": 2,
                "img_page": "ben/npm/images/story/about_missing/p2.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p2-d1.png", "ben/npm/images/story/about_missing/p2-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 4,
                "onelink": "https://dcard.link/Ld5zMN"
            },{
                "page": 3,
                "img_page": "ben/npm/images/story/about_missing/p3.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p3-d1.png", "ben/npm/images/story/about_missing/p3-d2.png", "ben/npm/images/story/about_missing/p3-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/b0DKa3"
            },{
                "page": 4,
                "img_page": "ben/npm/images/story/about_missing/p4.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p4-d1.png", "ben/npm/images/story/about_missing/p4-d2.png", "ben/npm/images/story/about_missing/p4-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/AmGRId"
            },{
                "page": 5,
                "img_page": "ben/npm/images/story/about_missing/p5.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p5-d1.png"],
                "img_dialog_time": [0.5],
                "duration": 1,
                "onelink": "https://dcard.link/OkUD5p"
            },{
                "page": 6,
                "img_page": "ben/npm/images/story/about_missing/p6.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p6-d1.png", "ben/npm/images/story/about_missing/p6-d2.png", "ben/npm/images/story/about_missing/p6-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/7Fn97n"
            },{
                "page": 7,
                "img_page": "ben/npm/images/story/about_missing/p7.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p7-d1.png", "ben/npm/images/story/about_missing/p7-d2.png", "ben/npm/images/story/about_missing/p7-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/uTcPzM"
            },{
                "page": 8,
                "img_page": "ben/npm/images/story/about_missing/p8.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p8-d1.png", "ben/npm/images/story/about_missing/p8-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/2MECns"
            },{
                "page": 9,
                "img_page": "ben/npm/images/story/about_missing/p9.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_missing/p9-d1.png"],
                "img_dialog_time": [0.5],
                "duration": 1,
                "onelink": "https://dcard.link/jEmZl0"
            }
        ],
        "choices": ["其實，我喜歡你", "那很怪欸！<br>而且我交男友了"],
        "choices_onelink": "https://dcard.link/jEmZl0",
        "download_onelink": "https://dcard.link/9VjGxq",
        "download_guide": "遲來的告白，該回應嗎？",
        "ending_script": [
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_missing/1/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/1/p1-d1.png", "ben/npm/images/ending/about_missing/1/p1-d2.png", "ben/npm/images/ending/about_missing/1/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_missing_ending1_page1"
                },{
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_missing/1/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/1/p2-d1.png", "ben/npm/images/ending/about_missing/1/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_missing_ending1_page2"
                },{
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_missing/1/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/1/p3-d1.png", "ben/npm/images/ending/about_missing/1/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_missing_ending1_page3"
                },{
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_missing/1/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/1/p4-d1.png"],
                    "img_dialog_time": [0.5],
                    "duration": 1,
                    "ga": "view_story_about_missing_ending1_page4"
                }
            ],
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_missing/2/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/2/p1-d1.png", "ben/npm/images/ending/about_missing/2/p1-d2.png", "ben/npm/images/ending/about_missing/2/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_missing_ending2_page1"
                },{
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_missing/2/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/2/p2-d1.png", "ben/npm/images/ending/about_missing/2/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_missing_ending2_page2"
                },{
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_missing/2/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/2/p3-d1.png", "ben/npm/images/ending/about_missing/2/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_missing_ending2_page3"
                },{
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_missing/2/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/2/p4-d1.png", "ben/npm/images/ending/about_missing/2/p4-d2.png", "ben/npm/images/ending/about_missing/2/p4-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_missing_ending2_page4"
                },{
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_missing/2/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/2/p5-d1.png", "ben/npm/images/ending/about_missing/2/p5-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_missing_ending2_page5"
                },{
                    "page": 6,
                    "img_page": "ben/npm/images/ending/about_missing/2/p6.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_missing/2/p6-d1.png"],
                    "img_dialog_time": [0.5],
                    "duration": 1,
                    "ga": "view_story_about_missing_ending2_page6"
                }
            ]
        ],
        "share_onelink": "https://dcard.link/AZSwnM",
        "article": [
            {
                "img": "ben/npm/images/ending/article/about_missing.png",
                "link": "https://www.dcard.tw/f/relationship/p/227351896?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=227351896&hba=true",
                "ga": "click_story_about_missing_post_wedding_227351896"
            }
        ]
    },{
        "story": "about_kindness",
        "opening_date": "2023, 11, 11",
        "name": "媽，我回來了",
        "intro": "一位行動不便的婆婆向我搭話，轉頭看著她佈滿歲月痕跡的臉，讓我想起了在家鄉的親人。<br>有多久沒回家了呢？",
        "qrcode": "ben/npm/images/cover/qrcode-about_kindness.png",
        "cover": "ben/npm/images/cover/about_kindness.png",
        "cover_onelink": "https://dcard.link/BZb6rq",
        "story_script": [
            {
                "page": 1,
                "img_page": "ben/npm/images/story/about_kindness/p1.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p1-d1.png", "ben/npm/images/story/about_kindness/p1-d2.png", "ben/npm/images/story/about_kindness/p1-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/NJ5xQc"
            },{
                "page": 2,
                "img_page": "ben/npm/images/story/about_kindness/p2.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p2-d1.png", "ben/npm/images/story/about_kindness/p2-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/HkAS8j"
            },{
                "page": 3,
                "img_page": "ben/npm/images/story/about_kindness/p3.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p3-d1.png", "ben/npm/images/story/about_kindness/p3-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/NnqarC"
            },{
                "page": 4,
                "img_page": "ben/npm/images/story/about_kindness/p4.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p4-d1.png", "ben/npm/images/story/about_kindness/p4-d2.png", "ben/npm/images/story/about_kindness/p4-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/7E0QGZ"
            },{
                "page": 5,
                "img_page": "ben/npm/images/story/about_kindness/p5.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p5-d1.png", "ben/npm/images/story/about_kindness/p5-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/pg1GF0"
            },{
                "page": 6,
                "img_page": "ben/npm/images/story/about_kindness/p6.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p6-d1.png", "ben/npm/images/story/about_kindness/p6-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/Db9tuZ"
            },{
                "page": 7,
                "img_page": "ben/npm/images/story/about_kindness/p7.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p7-d1.png", "ben/npm/images/story/about_kindness/p7-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/lmGPku"
            },{
                "page": 8,
                "img_page": "ben/npm/images/story/about_kindness/p8.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p8-d1.png"],
                "img_dialog_time": [0.5],
                "duration": 1,
                "onelink": "https://dcard.link/gkIhGX"

            },{
                "page": 9,
                "img_page": "ben/npm/images/story/about_kindness/p9.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_kindness/p9-d1.png", "ben/npm/images/story/about_kindness/p9-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 1.5,
                "onelink": "https://dcard.link/kv2h9h"

            }
        ],
        "choices": ["偷塞 500 元<br>到她的籃子裡", "多坐一站<br>問她需要幫忙嗎？"],
        "choices_onelink": "https://dcard.link/kv2h9h",
        "download_onelink": "https://dcard.link/2b8ecM",
        "download_guide": "她提出意想不到的請求⋯",
        "ending_script": [
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_kindness/1/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_kindness/1/p1-d1.png", "ben/npm/images/ending/about_kindness/1/p1-d2.png", "ben/npm/images/ending/about_kindness/1/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_kindness_ending1_page1"
                },{
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_kindness/1/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_kindness/1/p2-d1.png", "ben/npm/images/ending/about_kindness/1/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_kindness_ending1_page2"
                },{
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_kindness/1/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_kindness/1/p3-d1.png", "ben/npm/images/ending/about_kindness/1/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_kindness_ending1_page3"
                },
            ],
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_kindness/2/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_kindness/2/p1-d1.png", "ben/npm/images/ending/about_kindness/2/p1-d2.png", "ben/npm/images/ending/about_kindness/2/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_kindness_ending2_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_kindness/2/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_kindness/2/p2-d1.png", "ben/npm/images/ending/about_kindness/2/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_kindness_ending2_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_kindness/2/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_kindness/2/p3-d1.png", "ben/npm/images/ending/about_kindness/2/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_kindness_ending2_page3"
                }
            ]
        ],
        "share_onelink": "https://dcard.link/CeYqOc",
        "article": [
            {
                "img": "ben/npm/images/ending/article/about_kindness-1.png",
                "link": "https://www.dcard.tw/f/mood/p/750400?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=750400&hba=true",
                "ga": "click_story_about_kindness_post_happybirthday_750400"
            },
            {
                "img": "ben/npm/images/ending/article/about_kindness-2.png",
                "link": "https://www.dcard.tw/f/mood/p/226082390?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=226082390&hba=true",
                "ga": "click_story_about_kindness_post_priorityseat_226082390"
            },
            {
                "img": "ben/npm/images/ending/article/about_kindness-3.png",
                "link": "https://www.dcard.tw/f/mood/p/225118805?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=225118805&hba=true",
                "ga": "click_story_about_kindness_post_mrtboy_225118805"
            },
        ]
    },
    {
        "story": "about_forgiveness",
        "opening_date": "2023, 11, 18",
        "name": "直球對決，很難嗎？",
        "intro": "在充滿人潮的捷運上，和兩顆愛慕的心不期而遇。<br>我成了他們的旁觀者，發現自己也被這段愛情所牽動。",
        "qrcode": "ben/npm/images/cover/qrcode-about_forgiveness.png",
        "cover": "ben/npm/images/cover/about_forgiveness.png",
        "cover_onelink": "https://dcard.link/RPWGGR",
        "story_script": [
            {
                "page": 1,
                "img_page": "ben/npm/images/story/about_forgiveness/p1.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_forgiveness/p1-d1.png", "ben/npm/images/story/about_forgiveness/p1-d2.png", "ben/npm/images/story/about_forgiveness/p1-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/ok0Le2"
            },{
                "page": 2,
                "img_page": "ben/npm/images/story/about_forgiveness/p2.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_forgiveness/p2-d1.png", "ben/npm/images/story/about_forgiveness/p2-d2.png"],
                "img_dialog_time": [0.3, 1.5],
                "duration": 2,
                "onelink": "https://dcard.link/uLlKj5"
            },{
                "page": 3,
                "img_page": "ben/npm/images/story/about_forgiveness/p3.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_forgiveness/p3-d1.png", "ben/npm/images/story/about_forgiveness/p3-d2.png", "ben/npm/images/story/about_forgiveness/p3-d3.png"],
                "img_dialog_time": [0.3, 1.5, 2.7],
                "duration": 3,
                "onelink": "https://dcard.link/soXg8K"
            },{
                "page": 4,
                "img_page": "ben/npm/images/story/about_forgiveness/p4.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_forgiveness/p4-d1.png", "ben/npm/images/story/about_forgiveness/p4-d2.png", "ben/npm/images/story/about_forgiveness/p4-d3.png"],
                "img_dialog_time": [0.3, 1.5, 2.7],
                "duration": 3,
                "onelink": "https://dcard.link/xtb3US"
            },{
                "page": 5,
                "img_page": "ben/npm/images/story/about_forgiveness/p5.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_forgiveness/p5-d1.png", "ben/npm/images/story/about_forgiveness/p5-d2.png", "ben/npm/images/story/about_forgiveness/p5-d3.png"],
                "img_dialog_time": [0.3, 1.5, 2.7],
                "duration": 3,
                "onelink": "https://dcard.link/7mdsUP"
            },{
                "page": 6,
                "img_page": "ben/npm/images/story/about_forgiveness/p6.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_forgiveness/p6-d1.png"],
                "img_dialog_time": [0.3],
                "duration": 1,
                "onelink": "https://dcard.link/BUZz7c"
            }
        ],
        "choices": ["想辦法幫幫他們", "不打擾<br>是我的溫柔"],
        "choices_onelink": "https://dcard.link/BUZz7c",
        "download_onelink": "https://dcard.link/YzsuH1",
        "download_guide": "再不開口⋯她會被追走嗎",
        "ending_script": [
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_forgiveness/1/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/1/p1-d1.png", "ben/npm/images/ending/about_forgiveness/1/p1-d2.png", "ben/npm/images/ending/about_forgiveness/1/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_forgiveness_ending1_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_forgiveness/1/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/1/p2-d1.png", "ben/npm/images/ending/about_forgiveness/1/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending1_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_forgiveness/1/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/1/p3-d1.png", "ben/npm/images/ending/about_forgiveness/1/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending1_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_forgiveness/1/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/1/p4-d1.png", "ben/npm/images/ending/about_forgiveness/1/p4-d2.png", "ben/npm/images/ending/about_forgiveness/1/p4-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_forgiveness_ending1_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_forgiveness/1/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/1/p5-d1.png", "ben/npm/images/ending/about_forgiveness/1/p5-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending1_page5"
                },
                {
                    "page": 6,
                    "img_page": "ben/npm/images/ending/about_forgiveness/1/p6.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/1/p6-d1.png", "ben/npm/images/ending/about_forgiveness/1/p6-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending1_page6"
                },
                {
                    "page": 7,
                    "img_page": "ben/npm/images/ending/about_forgiveness/1/p7.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/1/p7-d1.png", "ben/npm/images/ending/about_forgiveness/1/p7-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending1_page7"
                }
            ],
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p1-d1.png", "ben/npm/images/ending/about_forgiveness/2/p1-d2.png", "ben/npm/images/ending/about_forgiveness/2/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_forgiveness_ending2_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p2-d1.png", "ben/npm/images/ending/about_forgiveness/2/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending2_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p3-d1.png", "ben/npm/images/ending/about_forgiveness/2/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending2_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p4-d1.png"],
                    "img_dialog_time": [0.5],
                    "duration": 1,
                    "ga": "view_story_about_forgiveness_ending2_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p5-d1.png", "ben/npm/images/ending/about_forgiveness/2/p5-d2.png", "ben/npm/images/ending/about_forgiveness/2/p5-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_forgiveness_ending2_page5"
                },
                {
                    "page": 6,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p6.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p6-d1.png", "ben/npm/images/ending/about_forgiveness/2/p6-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_forgiveness_ending2_page6"
                },
                {
                    "page": 7,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p7.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p7-d1.png", "ben/npm/images/ending/about_forgiveness/2/p7-d2.png", "ben/npm/images/ending/about_forgiveness/2/p7-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_forgiveness_ending2_page7"
                },
                {
                    "page": 8,
                    "img_page": "ben/npm/images/ending/about_forgiveness/2/p8.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_forgiveness/2/p8-d1.png"],
                    "img_dialog_time": [0.5],
                    "duration": 1,
                    "ga": "view_story_about_forgiveness_ending2_page8"
                }
            ]
        ],
        "share_onelink": "https://dcard.link/3F7qcm",
        "article": [
            {
                "img": "ben/npm/images/ending/article/about_forgiveness-1.png",
                "link": "https://www.dcard.tw/f/relationship/p/621739?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=621739&hba=true",
                "ga": "click_story_about_forgiveness_post_music_621739"
            },
            {
                "img": "ben/npm/images/ending/article/about_forgiveness-2.png",
                "link": "https://www.dcard.tw/f/relationship/p/235344690?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=235344690&hba=true",
                "ga": "click_story_about_forgiveness_post_memo_235344690"
            }
        ]
    },{
        "story": "about_companion",
        "opening_date": "2023, 11, 25",
        "name": "謝謝你，陌生人",
        "intro": "一位疲憊的上班族，在深夜的捷運站，與落寞的老先生相遇。<br>發生什麼事，讓原本低潮的兩人，成為彼此心靈的救贖？",
        "qrcode": "ben/npm/images/cover/qrcode-about_companion.png",
        "cover": "ben/npm/images/cover/about_companion.png",
        "cover_onelink": "https://dcard.link/ZRiXXt",
        "story_script": [
            {
                "page": 1,
                "img_page": "ben/npm/images/story/about_companion/p1.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_companion/p1-d1.png", "ben/npm/images/story/about_companion/p1-d2.png", "ben/npm/images/story/about_companion/p1-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/iBUwe8"
            },{
                "page": 2,
                "img_page": "ben/npm/images/story/about_companion/p2.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_companion/p2-d1.png", "ben/npm/images/story/about_companion/p2-d2.png", "ben/npm/images/story/about_companion/p2-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/avt2Dq"
            },{
                "page": 3,
                "img_page": "ben/npm/images/story/about_companion/p3.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_companion/p3-d1.png", "ben/npm/images/story/about_companion/p3-d2.png", "ben/npm/images/story/about_companion/p3-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/shNOdw"
            },{
                "page": 4,
                "img_page": "ben/npm/images/story/about_companion/p4.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_companion/p4-d1.png", "ben/npm/images/story/about_companion/p4-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/4YG06w"
            },{
                "page": 5,
                "img_page": "ben/npm/images/story/about_companion/p5.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_companion/p5-d1.png?v=1206"],
                "img_dialog_time": [0.5],
                "duration": 1,
                "onelink": "https://dcard.link/KutrK6"
            }
        ],
        "choices": ["幫他買個暖暖包", "陪他說說話"],
        "choices_onelink": "https://dcard.link/KutrK6",
        "download_onelink": "https://dcard.link/IvGuQp",
        "download_guide": "沒想到我會這樣被拯救⋯",
        "ending_script": [
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_companion/1/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/1/p1-d1.png", "ben/npm/images/ending/about_companion/1/p1-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending1_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_companion/1/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/1/p2-d1.png", "ben/npm/images/ending/about_companion/1/p2-d2.png", "ben/npm/images/ending/about_companion/1/p2-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_companion_ending1_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_companion/1/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/1/p3-d1.png", "ben/npm/images/ending/about_companion/1/p3-d2.png", "ben/npm/images/ending/about_companion/1/p3-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_companion_ending1_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_companion/1/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/1/p4-d1.png"],
                    "img_dialog_time": [0.5],
                    "duration": 1,
                    "ga": "view_story_about_companion_ending1_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_companion/1/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/1/p5-d1.png", "ben/npm/images/ending/about_companion/1/p5-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending1_page5"
                }
            ],
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_companion/2/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/2/p1-d1.png", "ben/npm/images/ending/about_companion/2/p1-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending2_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_companion/2/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/2/p2-d1.png", "ben/npm/images/ending/about_companion/2/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending2_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_companion/2/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/2/p3-d1.png", "ben/npm/images/ending/about_companion/2/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending2_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_companion/2/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/2/p4-d1.png", "ben/npm/images/ending/about_companion/2/p4-d2.png", "ben/npm/images/ending/about_companion/2/p4-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_companion_ending2_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_companion/2/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/2/p5-d1.png", "ben/npm/images/ending/about_companion/2/p5-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending2_page5"
                },
                {
                    "page": 6,
                    "img_page": "ben/npm/images/ending/about_companion/2/p6.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/2/p6-d1.png", "ben/npm/images/ending/about_companion/2/p6-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending2_page6"
                },
                {
                    "page": 7,
                    "img_page": "ben/npm/images/ending/about_companion/2/p7.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_companion/2/p7-d1.png", "ben/npm/images/ending/about_companion/2/p7-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_companion_ending2_page7"
                }
            ]
        ],
        "share_onelink": "https://dcard.link/li3c04",
        "article": [
            {
                "img": "ben/npm/images/ending/article/about_companion-1.png",
                "link": "https://www.dcard.tw/f/mood/p/236168854?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=236168854&hba=true",
                "ga": "click_story_about_companion_post_college_life_231956366"
            },
            {
                "img": "ben/npm/images/ending/article/about_companion-2.png",
                "link": "https://www.dcard.tw/f/mood/p/231956366?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=231956366&hba=true",
                "ga": "click_story_about_companion_post_covid19_236168854"
            }
        ]
    },{
        "story": "about_courage",
        "opening_date": "2023, 11, 5",
        "name": "如果身邊是你愛的人",
        "intro": "他和她，一直是那種微妙的關係，這聖誕夜，機會就在眼前，他敢不敢跨出那一步？<br>從朋友變成...？",
        "qrcode": "ben/npm/images/cover/qrcode-about_courage.png",
        "cover": "ben/npm/images/cover/about_courage.png",
        "cover_onelink": "https://dcard.link/nUXhME",
        "story_script": [
            {
                "page": 1,
                "img_page": "ben/npm/images/story/about_courage/p1.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p1-d1.png", "ben/npm/images/story/about_courage/p1-d2.png", "ben/npm/images/story/about_courage/p1-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/bKsSbP"
            },{
                "page": 2,
                "img_page": "ben/npm/images/story/about_courage/p2.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p2-d1.png", "ben/npm/images/story/about_courage/p2-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/n6fYB1"
            },{
                "page": 3,
                "img_page": "ben/npm/images/story/about_courage/p3.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p3-d1.png", "ben/npm/images/story/about_courage/p3-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/WmPvs9"
            },
            {
                "page": 4,
                "img_page": "ben/npm/images/story/about_courage/p4.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p4-d1.png", "ben/npm/images/story/about_courage/p4-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/VS2gOt"
            },{
                "page": 5,
                "img_page": "ben/npm/images/story/about_courage/p5.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p5-d1.png", "ben/npm/images/story/about_courage/p5-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/4Xr03B"
            },{
                "page": 6,
                "img_page": "ben/npm/images/story/about_courage/p6.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p6-d1.png", "ben/npm/images/story/about_courage/p6-d2.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/RICzmJ"
            },{
                "page": 7,
                "img_page": "ben/npm/images/story/about_courage/p7.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p7-d1.png", "ben/npm/images/story/about_courage/p7-d2.png", "ben/npm/images/story/about_courage/p7-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/LrBBXB"
            },{
                "page": 8,
                "img_page": "ben/npm/images/story/about_courage/p8.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_courage/p8-d1.png"],
                "img_dialog_time": [0.5],
                "duration": 1,
                "onelink": "https://dcard.link/mU2jV1"
            }
        ],
        "choices": ["看向旁邊的妳", "假裝沒事地開玩笑"],
        "choices_onelink": "https://dcard.link/mU2jV1",
        "download_onelink": "https://dcard.link/VsAAQg",
        "download_guide": "95%單身仔看完都後悔⋯",
        "ending_script": [
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_courage/1/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/1/p1-d1.png", "ben/npm/images/ending/about_courage/1/p1-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_courage_ending1_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_courage/1/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/1/p2-d1.png", "ben/npm/images/ending/about_courage/1/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_courage_ending1_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_courage/1/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/1/p3-d1.png"],
                    "img_dialog_time": [0.5],
                    "duration": 1,
                    "ga": "view_story_about_courage_ending1_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_courage/1/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/1/p4-d1.png", "ben/npm/images/ending/about_courage/1/p4-d2.png", "ben/npm/images/ending/about_courage/1/p4-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_courage_ending1_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_courage/1/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/1/p5-d1.png", "ben/npm/images/ending/about_courage/1/p5-d2.png", "ben/npm/images/ending/about_courage/1/p5-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_courage_ending1_page5"
                }
            ],
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_courage/2/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/2/p1-d1.png", "ben/npm/images/ending/about_courage/2/p1-d2.png", "ben/npm/images/ending/about_courage/2/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_courage_ending2_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_courage/2/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/2/p2-d1.png", "ben/npm/images/ending/about_courage/2/p2-d2.png", "ben/npm/images/ending/about_courage/2/p2-d3.png", "ben/npm/images/ending/about_courage/2/p2-d4.png"],
                    "img_dialog_time": [0.5, 1, 1.5, 2],
                    "duration": 4,
                    "ga": "view_story_about_courage_ending2_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_courage/2/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/2/p3-d1.png", "ben/npm/images/ending/about_courage/2/p3-d2.png", "ben/npm/images/ending/about_courage/2/p3-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_courage_ending2_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_courage/2/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/2/p4-d1.png", "ben/npm/images/ending/about_courage/2/p4-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_courage_ending2_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_courage/2/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_courage/2/p5-d1.png", "ben/npm/images/ending/about_courage/2/p5-d2.png", "ben/npm/images/ending/about_courage/2/p5-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_courage_ending2_page5"
                }
            ]
        ],
        "share_onelink": "https://dcard.link/DUp7hw",
        "article": [
            {
                "img": "ben/npm/images/ending/article/about_courage.png",
                "link": "https://www.dcard.tw/f/relationship/p/227927295?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=227927295&hba=true",
                "ga": "click_story_about_courage_post_christmas_227927295"
            }
        ]
    },{
        "story": "about_love",
        "opening_date": "2023, 11, 11",
        "name": "你，一直都在",
        "intro": "她離開了他，也離開了這片土地，10 年後再次回來，卻發現心底的遺憾還在。<br>只是，分散後兩人還有機會嗎？",
        "qrcode": "ben/npm/images/cover/qrcode-about_love.png",
        "cover": "ben/npm/images/cover/about_love.png",
        "cover_onelink": "https://dcard.link/bBZR9I",
        "story_script": [
            {
                "page": 1,
                "img_page": "ben/npm/images/story/about_love/p1.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p1-d1.png", "ben/npm/images/story/about_love/p1-d2.png", "ben/npm/images/story/about_love/p1-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/jIMLsg"
            },{
                "page": 2,
                "img_page": "ben/npm/images/story/about_love/p2.png",
                "img_dialog_animation":true,
                "img_dialog": ["ben/npm/images/story/about_love/p2-d1.png", "ben/npm/images/story/about_love/p2-d2.png", "ben/npm/images/story/about_love/p2-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/uhCEVs"
            },{
                "page": 3,
                "img_page": "ben/npm/images/story/about_love/p3.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p3-d1.png", "ben/npm/images/story/about_love/p3-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/Rk4ebg"
            },{
                "page": 4,
                "img_page": "ben/npm/images/story/about_love/p4.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p4-d1.png", "ben/npm/images/story/about_love/p4-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/EfstYD"
            },{
                "page": 5,
                "img_page": "ben/npm/images/story/about_love/p5.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p5-d1.png", "ben/npm/images/story/about_love/p5-d2.png", "ben/npm/images/story/about_love/p5-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/2XbyuY"
            },{
                "page": 6,
                "img_page": "ben/npm/images/story/about_love/p6.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p6-d1.png", "ben/npm/images/story/about_love/p6-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/V6uq8j"
            },{
                "page": 7,
                "img_page": "ben/npm/images/story/about_love/p7.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p7-d1.png", "ben/npm/images/story/about_love/p7-d2.png", "ben/npm/images/story/about_love/p7-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/9S3lVD"
            },{
                "page": 8,
                "img_page": "ben/npm/images/story/about_love/p8.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p8-d1.png", "ben/npm/images/story/about_love/p8-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/dOYgH4"
            },{
                "page": 9,
                "img_page": "ben/npm/images/story/about_love/p9.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p9-d1.png", "ben/npm/images/story/about_love/p9-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/T5Wil2"
            },{
                "page": 10,
                "img_page": "ben/npm/images/story/about_love/p10.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p10-d1.png"],
                "img_dialog_time": [0.5],
                "duration": 1,
                "onelink": "https://dcard.link/tQ36Kj"
            },{
                "page": 11,
                "img_page": "ben/npm/images/story/about_love/p11.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_love/p11-d1.png", "ben/npm/images/story/about_love/p11-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/Juh6O6"
            }
        ],
        "choices": ["前往美國", "前往101"],
        "choices_onelink": "https://dcard.link/Juh6O6",
        "download_onelink": "https://dcard.link/tFjruy",
        "download_guide": "十年了，我要放棄你了嗎",
        "ending_script": [
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_love/1/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_love/1/p1-d1.png", "ben/npm/images/ending/about_love/1/p1-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_love_ending1_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_love/1/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_love/1/p2-d1.png", "ben/npm/images/ending/about_love/1/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_love_ending1_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_love/1/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_love/1/p3-d1.png", "ben/npm/images/ending/about_love/1/p3-d2.png", "ben/npm/images/ending/about_love/1/p3-d3.png", "ben/npm/images/ending/about_love/1/p3-d4.png"],
                    "img_dialog_time": [0.5, 1, 1.5, 2],
                    "duration": 4,
                    "ga": "view_story_about_love_ending1_page3"
                }
            ],
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_love/2/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_love/2/p1-d1.png", "ben/npm/images/ending/about_love/2/p1-d2.png", "ben/npm/images/ending/about_love/2/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_love_ending2_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_love/2/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_love/2/p2-d1.png", "ben/npm/images/ending/about_love/2/p2-d2.png", "ben/npm/images/ending/about_love/2/p2-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5, 2],
                    "duration": 4,
                    "ga": "view_story_about_love_ending2_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_love/2/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_love/2/p3-d1.png", "ben/npm/images/ending/about_love/2/p3-d2.png", "ben/npm/images/ending/about_love/2/p3-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_love_ending2_page3"
                }
            ]
        ],
        "share_onelink": "https://dcard.link/ntu1GZ",
        "article": [
            {
                "img": "ben/npm/images/ending/article/about_love.png",
                "link": "https://www.dcard.tw/f/relationship/p/242501116?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=242501116&hba=true",
                "ga": "click_story_about_love_post_ten_years_242501116"
            }
        ]
    },{
        "story": "about_reunion",
        "opening_date": "2023, 11, 18",
        "name": "年夜飯的困境",
        "intro": "身處夫家的廚房，準備大家的團圓飯，心中滿是對父親的愧疚和掛念...<br>今年除夕，要回家過嗎？",
        "qrcode": "ben/npm/images/cover/qrcode-about_reunion.png",
        "cover": "ben/npm/images/cover/about_reunion.png",
        "cover_onelink": "https://dcard.link/FcVVfQ",
        "story_script": [
            {
                "page": 1,
                "img_page": "ben/npm/images/story/about_reunion/p1.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_reunion/p1-d1.png", "ben/npm/images/story/about_reunion/p1-d2.png", "ben/npm/images/story/about_reunion/p1-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/3DDGXO"
            },{
                "page": 2,
                "img_page": "ben/npm/images/story/about_reunion/p2.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_reunion/p2-d1.png", "ben/npm/images/story/about_reunion/p2-d2.png", "ben/npm/images/story/about_reunion/p2-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/sWqC04"
            },{
                "page": 3,
                "img_page": "ben/npm/images/story/about_reunion/p3.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_reunion/p3-d1.png", "ben/npm/images/story/about_reunion/p3-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/jpeAya"
            },{
                "page": 4,
                "img_page": "ben/npm/images/story/about_reunion/p4.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_reunion/p4-d1.png", "ben/npm/images/story/about_reunion/p4-d2.png", "ben/npm/images/story/about_reunion/p4-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/aRVNue"
            },{
                "page": 5,
                "img_page": "ben/npm/images/story/about_reunion/p5.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_reunion/p5-d1.png", "ben/npm/images/story/about_reunion/p5-d2.png"],
                "img_dialog_time": [0.5, 1],
                "duration": 2,
                "onelink": "https://dcard.link/0m5d1t"
            },{
                "page": 6,
                "img_page": "ben/npm/images/story/about_reunion/p6.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_reunion/p6-d1.png", "ben/npm/images/story/about_reunion/p6-d2.png", "ben/npm/images/story/about_reunion/p6-d3.png"],
                "img_dialog_time": [0.5, 1, 1.5],
                "duration": 3,
                "onelink": "https://dcard.link/cZ1W4J"
            },{
                "page": 7,
                "img_page": "ben/npm/images/story/about_reunion/p7.png",
                "img_dialog_animation": true,
                "img_dialog": ["ben/npm/images/story/about_reunion/p7-d1.png"],
                "img_dialog_time": [0.5],
                "duration": 1,
                "onelink": "https://dcard.link/cNcqeR"
            }
        ],
        "choices": ["開口說要回家陪爸爸吃飯", "第一次在夫家過年，還是待著吧"],
        "choices_onelink": "https://dcard.link/cNcqeR",
        "download_onelink": "https://dcard.link/dKk42W",
        "download_guide": "婆婆到底回了什麼？",
        "ending_script": [
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_reunion/1/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/1/p1-d1.png", "ben/npm/images/ending/about_reunion/1/p1-d2.png", "ben/npm/images/ending/about_reunion/1/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_reunion_ending1_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_reunion/1/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/1/p2-d1.png", "ben/npm/images/ending/about_reunion/1/p2-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_reunion_ending1_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_reunion/1/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/1/p3-d1.png", "ben/npm/images/ending/about_reunion/1/p3-d2.png", "ben/npm/images/ending/about_reunion/1/p3-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_reunion_ending1_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_reunion/1/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/1/p4-d1.png", "ben/npm/images/ending/about_reunion/1/p4-d2.png", "ben/npm/images/ending/about_reunion/1/p4-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_reunion_ending1_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_reunion/1/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/1/p5-d1.png", "ben/npm/images/ending/about_reunion/1/p5-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_reunion_ending1_page5"
                },
                {
                    "page": 6,
                    "img_page": "ben/npm/images/ending/about_reunion/1/p6.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/1/p6-d1.png", "ben/npm/images/ending/about_reunion/1/p6-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_reunion_ending1_page6"
                }
            ],
            [
                {
                    "page": 1,
                    "img_page": "ben/npm/images/ending/about_reunion/2/p1.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/2/p1-d1.png", "ben/npm/images/ending/about_reunion/2/p1-d2.png", "ben/npm/images/ending/about_reunion/2/p1-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_reunion_ending2_page1"
                },
                {
                    "page": 2,
                    "img_page": "ben/npm/images/ending/about_reunion/2/p2.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/2/p2-d1.png", "ben/npm/images/ending/about_reunion/2/p2-d2.png", "ben/npm/images/ending/about_reunion/2/p2-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_reunion_ending2_page2"
                },
                {
                    "page": 3,
                    "img_page": "ben/npm/images/ending/about_reunion/2/p3.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/2/p3-d1.png", "ben/npm/images/ending/about_reunion/2/p3-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_reunion_ending2_page3"
                },
                {
                    "page": 4,
                    "img_page": "ben/npm/images/ending/about_reunion/2/p4.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/2/p4-d1.png", "ben/npm/images/ending/about_reunion/2/p4-d2.png"],
                    "img_dialog_time": [0.5, 1],
                    "duration": 2,
                    "ga": "view_story_about_reunion_ending2_page4"
                },
                {
                    "page": 5,
                    "img_page": "ben/npm/images/ending/about_reunion/2/p5.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/2/p5-d1.png", "ben/npm/images/ending/about_reunion/2/p5-d2.png", "ben/npm/images/ending/about_reunion/2/p5-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_reunion_ending2_page5"
                },
                {
                    "page": 6,
                    "img_page": "ben/npm/images/ending/about_reunion/2/p6.png",
                    "img_dialog_animation": true,
                    "img_dialog": ["ben/npm/images/ending/about_reunion/2/p6-d1.png", "ben/npm/images/ending/about_reunion/2/p6-d2.png", "ben/npm/images/ending/about_reunion/2/p6-d3.png"],
                    "img_dialog_time": [0.5, 1, 1.5],
                    "duration": 3,
                    "ga": "view_story_about_reunion_ending2_page6"
                }
            ]
        ],
        "share_onelink": "https://dcard.link/T0zP0T",
        "article": [
            {
                "img": "ben/npm/images/ending/article/about_reunion.png",
                "link": "https://www.dcard.tw/f/funny/p/228830613?utm_source=mrt_+website&utm_medium=ending_post&utm_campaign=228830613&hba=true",
                "ga": "click_story_about_reunion_post_dad_228830613"
            }
        ]
    },
]

